import { render } from "./DetailPDFTopNav.vue?vue&type=template&id=0ccb884e"
import script from "./DetailPDFTopNav.vue?vue&type=script&lang=js"
export * from "./DetailPDFTopNav.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\glenside-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__